// Generated by BUCKLESCRIPT VERSION 1.9.1, PLEASE EDIT WITH CARE
'use strict';

var Bs_fetch    = require("bs-fetch/lib/js/src/bs_fetch.js");
var Json_decode = require("bs-json/lib/js/src/json_decode.js");

function getLocalToken() {
  var ls = ( localStorage.getItem("githubToken") || "" );
  if (ls === "") {
    return /* None */0;
  } else {
    return /* Some */[ls];
  }
}

var setLocalToken = (
  function (token) {
    localStorage.setItem("githubToken", token);
  }
);

var deleteLocalToken = (
  function (token) {
    localStorage.removeItem("githubToken");
  }
);

function getCodeFromUrl() {
  var $$switch = (
    (window.location.href.match(/\?code=(.*)/) && window.location.href.match(/\?code=(.*)/)[1])
    ? window.location.href.match(/\?code=(.*)/)[1] : ''
  );
  if ($$switch === "") {
    return /* None */0;
  } else {
    return /* Some */[$$switch];
  }
}

var getLocationOrigin = (
  function () {
    return window.location.origin
  }  
);

var redirectToAuth = (
  function (clientId, redirectUri) {
    window.location = "https://github.com/login/oauth/authorize?scope=notifications&client_id=" + clientId + "&redirect_uri=" + redirectUri;
  }  
);

function decodeGatekeeperResponse(json) {
  return Json_decode.field("token", Json_decode.string, json);
}

function requestToken(code) {
  var reqInit = Bs_fetch.RequestInit[/* make */0](/* Some */[/* Post */2], /* Some */[/* array */[/* tuple */[
              "Content-Type",
              "text/plain"
            ]]], /* Some */["{ \"code\": \"" + (code + "\" }")], /* None */0, /* None */0, /* Some */[/* CORS */3], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0)(/* () */0);
  return fetch("https://gh-notification-api.now.sh", reqInit).then((function (prim) {
                  return prim.json();
                })).then((function (json) {
                return Promise.resolve(Json_decode.field("token", Json_decode.string, json));
              }));
}

function apiUrl(endpoint) {
  return "https://api.github.com/" + endpoint;
}

function makeRequest(token) {
  return Bs_fetch.RequestInit[/* make */0](/* None */0, /* Some */[/* array */[/* tuple */[
                    "Authorization",
                    "token " + token
                  ]]], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0)(/* () */0);
}

function makePatchRequest(token) {
  return Bs_fetch.RequestInit[/* make */0](/* Some */[/* Patch */8], /* Some */[/* array */[/* tuple */[
                    "Authorization",
                    "token " + token
                  ]]], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0)(/* () */0);
}

function user(token) {
  return fetch("https://api.github.com/user", makeRequest(token)).then((function (prim) {
                  return prim.text();
                })).then((function (jsonText) {
                return Promise.resolve(jsonText);
              }));
}

function notifications(token) {
  return fetch("https://api.github.com/notifications", makeRequest(token)).then((function (prim) {
                  return prim.text();
                })).then((function (prim) {
                return Promise.resolve(prim);
              }));
}

function readNotification(token, id) {
  return fetch("https://api.github.com/notifications/threads/" + id, makePatchRequest(token)).then((function (response) {
                return Promise.resolve(+(response.status === 205));
              }));
}

exports.getLocalToken            = getLocalToken;
exports.setLocalToken            = setLocalToken;
exports.deleteLocalToken         = deleteLocalToken;
exports.getCodeFromUrl           = getCodeFromUrl;
exports.getLocationOrigin        = getLocationOrigin;
exports.redirectToAuth           = redirectToAuth;
exports.decodeGatekeeperResponse = decodeGatekeeperResponse;
exports.requestToken             = requestToken;
exports.apiUrl                   = apiUrl;
exports.makeRequest              = makeRequest;
exports.makePatchRequest         = makePatchRequest;
exports.user                     = user;
exports.notifications            = notifications;
exports.readNotification         = readNotification;
/* setLocalToken Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/github.re
// module id = 55
// module chunks = 0